import React from 'react';
import cl from './HomeInfo.module.css';
import { NavLink } from 'react-router-dom';

const HomeInfo = () => {
  return (
    <section className={cl.about}>
      <NavLink className={cl.link_image} to="/products">
        <div className={cl.sale_image}>
          <span>Remises jusqu'à -90%</span>
          <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><title/><g><path d="M22,9a1,1,0,0,0,0,1.42l4.6,4.6H3.06a1,1,0,1,0,0,2H26.58L22,21.59A1,1,0,0,0,22,23a1,1,0,0,0,1.41,0l6.36-6.36a.88.88,0,0,0,0-1.27L23.42,9A1,1,0,0,0,22,9Z"/></g></svg>
        </div>
      </NavLink>
      <NavLink className={cl.link_image} to="/about">
        <img
          className={cl.big_image}
          src="https://chodniki.com/img/cms/o_nas_FR.jpg"
        />
      </NavLink>
    </section>
  );
};

export default HomeInfo;
